import fetch from 'unfetch';
import useSWRInfinite from 'swr/infinite';

const fetcher = (...args) => fetch(...args).then((res) => res.json());
const urlifyArray = (str) => encodeURIComponent(JSON.stringify(str));
const urlify = (str) => encodeURIComponent(str);

const PAGE_SIZE = 5;

export default function usePages({ categories = [], language = 'fi' }) {
  const {
    data, error, size, setSize, isValidating,
  } = useSWRInfinite((index, previousData) => {
    // Last page.
    if (previousData && previousData.pages === index) { return null; }

    return `/wp-json/odl/v1/document-listing/?lang=${urlify(language)}&taxonomy=category&terms=${urlifyArray(categories)}&per_page=${PAGE_SIZE}&page=${index + 1}`;
  }, fetcher);

  const isLoadingInitialData = !data && !error;

  return {
    page: data,
    size,
    setSize,
    isValidating,
    isLoadingInitialData,
    isError: error,
  };
}
